// Deterministic hash-based color for any log type name.
// Same input always produces the same color, regardless of what other log types exist.

export function getLogTypeColor(logType) {
  let hash = 0
  for (let i = 0; i < logType.length; i++) {
    hash = logType.charCodeAt(i) + ((hash << 5) - hash)
  }
  const hue = ((hash % 360) + 360) % 360
  return `hsl(${hue}, 65%, 55%)`
}
